import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { joinCss } from "../helpers/utils";

import classes from "./QAndA.module.scss";
import appClasses from "../App.module.scss";

class qAndA extends Component {
  state = {
    en: false,
    data: {}
  };

  render() {
    var enDiv = this.props.en ? classes["qAndA-en"] : "";
    var enQuestion = this.props.en ? classes["question-en"] : "";
    var enAnswer = this.props.en ? classes["answer-en"] : "";

    return (
      <div className={joinCss(classes.qAndA, enDiv)}>
        <Container className="mt-5 px-0">
          <Row className="mx-0">
            <Col
              className={joinCss(
                classes.qAndAMargin,
                classes.question,
                "sm-11",
                "md-10",
                appClasses["vertical-center-parent"],
                enQuestion
              )}
            >
              <span className={classes["vertical-QAndA-center-child-q"]}>
                {this.props.data.id + " | " + this.props.data.question}
              </span>
            </Col>
          </Row>
          <Row className="mx-0">
            <Col
              className={joinCss(
                classes.qAndAMargin,
                classes.answer,
                "xs-12",
                "md-10",
                appClasses["vertical-center-parent"],
                enAnswer
              )}
            >
              <span className={classes["vertical-QAndA-center-child-a"]}>
                {this.props.data.answer}
              </span>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default qAndA;
